import React, { Suspense, lazy } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';

const getLazyComponent = {
    FormApproval: lazy(() => import('../approval/FormApproval')),
    CreateNewFlow: lazy(() => import('../flows/CreateNewFlow')),
    ConfigurationFlow: lazy(() => import('../../screens/flows/detailsFlow/ConfigurationFlow')),
    TeamsScheduler: lazy(() => import('../../screens/crm/components/TeamsScheduler')),
};

export const GenericModal = ({ open, accion, handleClose, item, data }) => {
    const LazyComponent = getLazyComponent[item.config.component];
    if (!LazyComponent) return null;

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>{accion}</DialogTitle>
            <DialogContent sx={{ mb: 2 }}>
                <Suspense fallback={<div>Cargando...</div>}>
                    <LazyComponent
                        handleClose={handleClose}
                        data={data}
                    />
                </Suspense>
            </DialogContent>
        </Dialog>
    );
};
